import { H1, Spin } from 'platform-components';
import React from 'react';
import { useMount } from 'react-use';
import ym from 'react-yandex-metrika';

import PageContentTitle from 'common.components/page-content-title/page-content-title';
import { SpecCourseStub } from 'common.components/spec-course-stub/spec-course-stub';

import { SpecCourseHeader } from '../../spec-course.header/header';

interface Props {
    isLoading: boolean;
    teamLetter: string | null;
    teamNumber: number | null;
}

export const SpecCourseStubContent = ({ isLoading, teamLetter, teamNumber }: Props) => {
    useMount(function sendMetrika() {
        setTimeout(() => {
            ym('reachGoal', 'teacher_olymp_empty_state');
        }, 0);
    });

    return (
        <div className="spec-course-container">
            <SpecCourseHeader />
            <div className="spec-course-container__content">
                <div className="spec-course-container__page-content-title">
                    <PageContentTitle
                        title={<H1 id="specCourse.content.title" values={{ teamLetter, teamNumber }} />}
                    />
                </div>
                <div className="spec-course-container__wrapper">
                    {isLoading ? <Spin center /> : <SpecCourseStub textId="specCourse.stub.teacher" />}
                </div>
            </div>
        </div>
    );
};
